"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Manutech = void 0;
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var Manutech = (function (_super) {
    __extends(Manutech, _super);
    function Manutech() {
        return _super.call(this, {
            name: CardName_1.CardName.MANUTECH,
            tags: [Tags_1.Tags.BUILDING],
            startingMegaCredits: 35,
            cardType: CardType_1.CardType.CORPORATION,
            productionBox: Units_1.Units.of({ steel: 1 }),
            metadata: {
                cardNumber: 'R23',
                description: 'You start with 1 steel production, and 35 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br.br;
                    b.production(function (pb) { return pb.steel(1); }).nbsp.megacredits(35);
                    b.corpBox('effect', function (ce) {
                        ce.effect('For each step you increase the production of a resource, including this, you also gain that resource.', function (eb) {
                            eb.production(function (pb) { return pb.wild(1); }).startEffect.wild(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    Manutech.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    };
    Manutech.onProductionGain = function (player, resource, amount) {
        if (amount > 0) {
            player.addResource(resource, amount);
        }
    };
    return Manutech;
}(Card_1.Card));
exports.Manutech = Manutech;
